/**
 * External Dependencies
 * Comment out scripts that are not used to save on page load
 */
import { Alert, Button, Collapse, Dropdown, Modal, Tab } from 'bootstrap';
// import 'bootstrap-select';
import AOS from 'aos';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/lazysizes';
// import 'ics';
// import '@lottiefiles/lottie-player';

/**
 * Internal Scripts
 * Comment out scripts that are not used to save on page load
 */
// import './disclaimer.js';
import './people.js';
import './news.js';
import './animations.js';
// import './calendar.js';
import './slider.js';
import './parallax.js';

const $window = $(window);
const $body = $('body');

// Hide show back to top links.
const backToTop = (el) => {
  if (window.pageYOffset > 300) {
    $(el).fadeIn();
  } else {
    $(el).fadeOut();
  }

  document.querySelectorAll(el).forEach(function(element, index) {
    element.addEventListener('click', function() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, { once: true });
  });
};

// Smooth scroll to
$(() => {
  $('.nav-link').click(function () {
    if (!$(this).hasClass("dropdown-toggle")) {
      const $link = $('.nav-link');
      const sectionTo = $(this).attr('href').replace(new RegExp('/', ''),"");
      const header = $('.header').height();
      const navbar = $('#navbar');
      const $this = $(this);

      $link.removeClass('active');
      $this.addClass('active');

      $(navbar).collapse('hide');

      $('html,body').animate({
        scrollTop: $(sectionTo).offset().top - header
      }, 500);
    }
  });
});

// Add scroll class on scroll/load
$(() => {
  $window.on("scroll load", function() {
    if($window.scrollTop() > 50) {
      $body.addClass("scroll-down");
    } else {
      //remove the background property so it comes transparent again (defined in your css)
      $body.removeClass("scroll-down");
    }
  });
});

$(() => {

  AOS.init({
    once: true,
    disableMutationObserver: false,
  });

  AOS.refresh(true);

  // Get CSS variables
  let root = getComputedStyle(document.documentElement);
  let colorPrimary = root.getPropertyValue('--primary');
  let colorSecondary = root.getPropertyValue('--secondary');
  let xsBreakpoint = root.getPropertyValue('--breakpoint-xs').replace('px','');
  let smBreakpoint = root.getPropertyValue('--breakpoint-sm').replace('px','');
  let mdBreakpoint = root.getPropertyValue('--breakpoint-md').replace('px','');
  let lgBreakpoint = root.getPropertyValue('--breakpoint-lg').replace('px','');
  let xlBreakpoint = root.getPropertyValue('--breakpoint-xl').replace('px','');

  // Scroll to open accordion
  // see example https://stackoverflow.com/questions/35992900/bootstrap-accordion-scroll-to-top-of-active-open-accordion-on-click#answer-35992958
  $('.accordion-collapse').on('shown.bs.collapse', function (e) {
    const header = $('.header').height();
    var $panel = $(this).closest('.accordion-item');
    $('html,body').animate({
      scrollTop: $panel.offset().top - header,
    }, 500); 
  });

  // Enable bootstrap select for all selects
  // $('select').selectpicker();

  window.addEventListener('scroll', function() {
    backToTop('#back2top');
  });

  var $headerBackground = $('.header-background');
  $('.mega-menu.collapse').on('show.bs.collapse', function() {
    $('.mega-menu.collapse.show').not(this).collapse('hide');
  });

  // Remove existing click event handler for dropdown toggles
  $('.dropdown-toggle').off('click');

  // Add new click event handler
  $('.dropdown-toggle').on('click', function(e) {
    e.preventDefault();
    var $megaMenu = $(this).next('.mega-menu.collapse');
    $megaMenu.collapse('toggle');
  });
  
  $('.mega-menu.collapse').on('hidden.bs.collapse', function() {
    // Add a small delay before checking for open menus
    setTimeout(() => {
      if ($('.mega-menu.collapse.show').length === 0) {
        $headerBackground.removeClass('menu-open');
      }
    }, 50);
  });

  $('.mega-menu.collapse').on('show.bs.collapse', function() {
    $headerBackground.addClass('menu-open');
  });

  $(document).on('click', function (event) {
    if (!$(event.target).closest('.mega-menu, .dropdown-toggle').length) {
      $('.mega-menu.collapse').collapse('hide');
      $headerBackground.removeClass('menu-open');
    }
  });
  
  $(document).on('keyup', function (event) {
    if (event.key === 'Escape') {
      $('.mega-menu.collapse').collapse('hide');
      $headerBackground.removeClass('menu-open');
    }
  });

  var $slides = $('.text-rotate__text');
  var currentSlide = 0;
  var slideInterval = setInterval(nextSlide, 2000);

  function nextSlide() {
    $slides.eq(currentSlide).removeClass('-active');
    currentSlide = (currentSlide + 1) % $slides.length;
    $slides.eq(currentSlide).addClass('-active');
  }
});

window.addEventListener('load', function () {
  backToTop('#back2top');
}, false);